// Import Quill first to ensure it's fully loaded
// eslint-disable-next-line import/no-extraneous-dependencies
import Quill from 'quill'

// Make Quill globally available for plugins that expect it
window.Quill = Quill

// Create a safety wrapper for the image resize module
const setupImageResize = async () => {
    try {
        // Dynamic import to ensure Quill is fully initialized
        // eslint-disable-next-line import/no-extraneous-dependencies
        const ImageResizeModule = await import('quill-image-resize-module')
        const ImageResize = ImageResizeModule.default || ImageResizeModule

        // Only register if both are available
        if (Quill && Quill.imports && ImageResize) {
            Quill.register('modules/imageResize', ImageResize)
        }
    } catch (error) {
        console.warn('Error registering quill-image-resize-module:', error)
    }
}

// Run the setup after a small delay to ensure Quill is fully loaded
setTimeout(setupImageResize, 0)

export default Quill
